/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
<<<<<<< HEAD
 * @LastEditTime: 2024-09-06 20:47:49
=======
<<<<<<< HEAD
 * @LastEditTime: 2024-06-05 10:05:33
=======
 * @LastEditTime: 2024-04-30 08:36:31
>>>>>>> 144c7765abb3e9971bcc505c4169164c9288ca59
>>>>>>> 2aa4bc500bd2b1b60a7c00f5f8a4d0abf0e8c7da
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/common/env.js
 */

const development = {
  // yapiUrl: "http://120.79.151.212:3000/mock/15", // mock
  baseUrl: 'https://dev.meiql.com' // server
  // baseUrl: 'http://192.168.0.101:4000' // server
}
/**
 * @Auther: Qsan 13107476463 8539240
 * @Date：2018年12月12日 16:31
 * @Desc：环境变量配置
 */

let config = {
  dev: {
    // yapiUrl: "/yapiAPI", // mock
   baseUrl: 'https://dev.meiql.cn' // 测试环境

    // baseUrl: 'http://192.168.0.101:4000' // 测试环境
    //baseUrl: 'https://pro.meiql.com' // 正式环境
    // baseUrl: 'http://192.168.0.104:4001'
    //  baseUrl: 'http://192.168.0.100:4000'

  },
  development: development, // 开发环境
  testing: {
    yapiUrl: 'http://120.79.151.212:3000/mock/15', // mock
    // baseUrl: 'http://47.107.145.71:4000' // server
    // baseUrl: "http://192.168.2.105:4000" // server新+
    baseUrl: 'https://dev.meiql.cn' // 测试环境
    // baseUrl: 'http://192.168.0.101:4000' // 测试环境
  },
  production: {
    // 生产环境
    baseUrl: 'https://pro.meiql.com'
  }
}

let env = config[process.env.NODE_ENV]

export default env



// WEBPACK FOOTER //
// ./src/common/env.js